"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenAPI = void 0;
class OpenAPI {
    client;
    constructor(client) {
        this.client = client;
    }
    async getBot(botId, url) {
        const response = await this.client.get(`/chat/bots/${botId}`, {
            url,
        });
        return response;
    }
    async createConversation(botId, payload) {
        const response = await this.client.post(`/chat/bots/${botId}/conversations`, payload);
        return response;
    }
    async createSiteCompanionConversation(botId, payload) {
        const response = await this.client.post(`/chat/bots/${botId}/site-companion/conversations`, payload);
        return response;
    }
    async getWebChatConversation(uuid, conversationId) {
        const apiUrl = `/chat/guests/${uuid}/conversations/${conversationId}/messages`;
        const response = await this.client.get(apiUrl);
        return response;
    }
    async getSiteCompanionConversation(uuid, conversationId) {
        const apiUrl = `/chat/guests/${uuid}/site-companion/conversations/${conversationId}/messages`;
        const response = await this.client.get(apiUrl);
        return response;
    }
    async getUniversalConversation(uuid) {
        const apiUrl = `/chat/universal_conversations/${uuid}/messages`;
        const response = await this.client.get(apiUrl);
        return response;
    }
    async sendMessage(conversationId, payload) {
        const response = await this.client.post(`/chat/conversations/${conversationId}/messages`, payload);
        return response;
    }
    async sendMessageV2(conversationId, payload) {
        const response = await this.client.post(`v2/chat/conversations/${conversationId}/messages`, payload);
        return response;
    }
    async sendSiteCompanionMessage(conversationId, payload) {
        const response = await this.client.post(`/chat/site-companion/conversations/${conversationId}/messages`, payload);
        return response;
    }
    async getUserActionBoxInfo(uuid, conversationId) {
        const apiUrl = `/chat/guests/${uuid}/site-companion/conversations/${conversationId}/call-to-action`;
        const response = await this.client.get(apiUrl);
        return response;
    }
    async updateAnswerRating(botId, conversationId, payload) {
        const apiUrl = `/chat/bots/${botId}/conversations/${conversationId}/answer-rating`;
        const response = await this.client.post(apiUrl, payload);
        return response;
    }
    async createRelatedQuestions(uuid, conversationId, messageId) {
        const apiUrl = `/chat/guests/${uuid}/site-companion/conversations/${conversationId}/messages/${messageId}/related-questions`;
        const response = await this.client.post(apiUrl);
        return response;
    }
}
exports.OpenAPI = OpenAPI;
//# sourceMappingURL=OpenAPI.js.map